import { render, staticRenderFns } from "./ContactsFragmentDesktop.vue?vue&type=template&id=72f6a9c8&scoped=true&"
import script from "./ContactsFragmentDesktop.vue?vue&type=script&lang=js&"
export * from "./ContactsFragmentDesktop.vue?vue&type=script&lang=js&"
import style0 from "./ContactsFragmentDesktop.vue?vue&type=style&index=0&id=72f6a9c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f6a9c8",
  null
  
)

export default component.exports